// A raiz das queries da Agenda no react-query. Módulo SEM dependências, de propósito: o `NotificationContext`, o
// `useLembretes` e o `useGuardarNasNotas` invalidam a Agenda e não podem importar de `@/hooks/useCalendar` (puxa o
// `calendarService`/axios, e cinco testes da `CalendarPage` trocam esse módulo por uma factory que não exporta as
// chaves — o mesmo motivo de `lib/lembretes/cache.ts`). O `CALENDAR_KEYS` do `useCalendar` nasce desta raiz.
export const RAIZ_DA_AGENDA = ["calendar"] as const;

// A raiz das reservas de sala, aqui pelo mesmo motivo: excluir evento (useCalendar) invalida as reservas — a
// reserva ligada some junto — e cancelar reserva (useRoomReservations) invalida a Agenda; nenhum importa o outro.
export const RAIZ_DAS_RESERVAS = ["room-reservations"] as const;
